import { createEntityAdapter } from '@ngrx/entity';
import { sortByCustomerConnectedTimeAsc } from '../../common/helpers/conversion-comparers.helper';
import { MessageConversation } from '../models/message-conversation.model';

export const messageConversationEntityAdapter = createEntityAdapter<MessageConversation>({
  selectId: conversation => conversation.id,
  sortComparer: sortByCustomerConnectedTimeAsc
});
